export default {"src":"/_next/static/media/success-check.d897dd61.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};